export default __webpack_public_path__ + "static/-3450-42a0-a034-6188968ce577-8b669123ea721bf1c1bc7bce596675d5.mp4";